'use client';

import { Variants } from 'framer-motion';

/**
 * Page transition animation variants
 * These variants define the animation states for page transitions
 */

// Fade transition - smooth opacity change
export const fadeVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.2,
      ease: 'easeInOut',
    },
  },
};

// Slide from right - for forward navigation
export const slideRightVariants: Variants = {
  initial: {
    opacity: 0,
    x: 100,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    x: -100,
    transition: {
      duration: 0.2,
      ease: 'easeIn',
    },
  },
};

// Slide from left - for backward navigation
export const slideLeftVariants: Variants = {
  initial: {
    opacity: 0,
    x: -100,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    x: 100,
    transition: {
      duration: 0.2,
      ease: 'easeIn',
    },
  },
};

// Scale transition - zoom effect
export const scaleVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0.95,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.2,
      ease: 'easeIn',
    },
  },
};

// Zoom in transition - for detail pages
export const zoomVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0.8,
  },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.35,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.25,
      ease: [0.4, 0, 1, 1],
    },
  },
};

// Default transition for most pages
export const defaultPageVariants = fadeVariants;

/**
 * Transition configuration
 */
export const pageTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3,
};

/**
 * Get appropriate variant based on route
 */
export function getPageVariant(pathname: string): Variants {
  // Detail pages use zoom effect
  if (pathname.includes('/vehicle-detail/') || pathname.includes('/booking-flow')) {
    return zoomVariants;
  }
  
  // Default fade for all other pages
  return fadeVariants;
}
